const mod = require('../../bahabot.module.js')


/**
 * @param {TaggedMessagesService} TaggedMessagesService
 */
function bbTaggedMessagesComponent(TaggedMessagesService, $timeout, $http) {
    this.svc = TaggedMessagesService;
    TaggedMessagesService.get();

    this.clearFilter = (name) => {
        TaggedMessagesService.filters[name] = '';
    }

    this.editedRow = null;

    this.startEditing = (row) => {
        this.editedRow = {...row};
        $timeout(() => {
            document.querySelector("#tagEditInput").focus();
        }, 100)
    }

    this.stopEditing = (e) => {
        this.editedRow = null;
        e.stopPropagation();
    }

    this.handleKeydownEditing = (e) => {
        if (e.key === 'Escape') {
            return this.stopEditing(e);
        }
        if (e.key === 'Enter') {
            return this.commitEdited(e);
        }
    }

    this.commitEdited = (e) => {
        $http({
            method: 'PATCH',
            url: `/api/protected/tagged-messages/${this.editedRow.id}`,
            data: this.editedRow
        }).then((v) => {
            const local = this.svc.data.items.find(r => r.id === this.editedRow.id);
            if (local) {
                local.tag = this.editedRow.tag;
            }
            this.editedRow = null;
        })

        e.stopPropagation();
    }
}

mod.component('bbTaggedMessages', {
    templateUrl: 'tpl/bb-tagged-messages.component.html',
    bindings: {},
    controller: ["TaggedMessagesService", "$timeout", "$http", bbTaggedMessagesComponent]
});